// 72-hour edit window helper.
// Use isLocked(row.created_at) to decide whether to show a lock icon
// and disable the Edit button. The DB enforces the same rule via
// the guard_edit_window() trigger — this is purely UX hinting.

export const EDIT_WINDOW_HOURS = 72;

export function isLocked(createdAt: string | Date | null | undefined): boolean {
  if (!createdAt) return false;
  const created = typeof createdAt === "string" ? new Date(createdAt) : createdAt;
  const ageMs = Date.now() - created.getTime();
  return ageMs > EDIT_WINDOW_HOURS * 60 * 60 * 1000;
}

export const LOCKED_TOOLTIP = "Locked — older than 72 hours. Ask admin for changes.";
